<div class="panelhold" style= "text-align: center; border:1px solid #cdcdcd;">
    <div>
        <div class="col-md-12">
            <!-- <div class="wrapper"> -->
            <div class="">
            <router-outlet></router-outlet>
            <!-- <img id="idSpinner" [src]="loadingImage" alt='Loading...' width="30%" class="loading-img-center"/> -->
            <mat-progress-spinner id="idSpinner" class="spin mx-auto" [color]="spinColor" [mode]="spinMode"
                      [value]="spinValue" [diameter]="60" class="mat-progress-spinner">
             </mat-progress-spinner>

            <app-footer></app-footer>
            </div>
            
        </div>
       
</div>
</div>